<script lang="ts" setup>
import { support } from '@shared/config'
import { TextQuaternary } from '@shared/ui/typography'

import FooterCopyright from './FooterCopyright.vue'

defineOptions({
  name: 'FooterMenu',
})

</script>

<template>
  <nav class="footer-menu">
    <FooterCopyright class="mobile" />
    <TextQuaternary
      class="footer-menu__item"
    >
      {{ support.email }}
    </TextQuaternary>
    <TextQuaternary
      v-once
      class="footer-menu__item"
    >
      Address Las Vegas, USA
    </TextQuaternary>
  </nav>
</template>

<style scoped lang="scss" src="./FooterMenu.scss" />
